<template>
    <header v-if="$route.path === `/${path}`" class="details-header layout-header">
        <van-icon name="arrow-left" @click="$router.go(-1)"></van-icon>
        <b>{{headerTitle}}</b>
    </header>
</template>
<script>
export default {
    name: "ProductDetailsHeader",
    props: ["path", "headerTitle"]
}
</script>
<style scoped>
/* 商品详情组件头部 */
.details-header {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
}

.details-header .van-icon {
    position: absolute;
    left: 15px;
    /* color: var(--red-light); */
    font-size: 20px;
}
</style>